import React, { FC, useCallback, useState } from "react";
import _ from "lodash";
import F7 from "../../../utils/F7";
import Image from "../../common/F7/Image";
import Spinner from "../../common/F7/Spinner";
import { ListFeature } from "../InventoryMapListPage";
import { ImageObject } from "../../../hooks/database/types/inventories";
import { isModernImageObject, useGetImage } from "../../../utils/image";
import { isType } from "../../../utils/utils";

const ListImages: FC<{ features: (ListFeature & { distance: number })[]; selectedFeatures: Record<string, ol.Feature> }> = (props) => {
  const [loading, setLoading] = useState(false);

  const getImage = useGetImage();

  const showPhotoBrowser = useCallback(
    (features: { id: string; title: string; image: ImageObject; distance: number }[], selectedIndex: number) => {
      setLoading(true);

      const image = features[selectedIndex].image;
      const title = features[selectedIndex].title;
      getImage(image).then((imageUrl) => {
        setLoading(false);
        const browser = F7.photoBrowser({
          photos: [
            {
              url: imageUrl,
              caption: title,
            },
          ],
          type: "popup",
          toolbar: false,
          exposition: false,
        });

        browser.open();
      });
    },
    [getImage]
  );

  const features = props.features
    .filter((feature) => props.selectedFeatures[feature.id])
    .flatMap((feature) =>
      feature.formdata
        .filter((d) => d && d.values)
        .flatMap((data, idx1) =>
          Object.values(data.values)
            .filter(isType("type", "image"))
            .filter((value) => !!value.value)
            .flatMap((value, idx2) =>
              value.value!.map((image, idx3) => ({
                id: feature.id,
                title: feature.title,
                image: image,
                distance: feature.distance,
                imageId: isModernImageObject(image) ? image.imageId : `${feature.id}_${idx1}_${idx2}_${idx3}`,
              }))
            )
        )
    );

  if (features.length < 1) {
    return null;
  }

  return (
    <div>
      {loading ? <Spinner /> : null}
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          height: 88,
          width: "100%",
          zIndex: 2000,
          backgroundColor: "rgb(255, 255, 255)",
          overflowX: "scroll",
          overflowY: "hidden",
          whiteSpace: "nowrap",
          paddingRight: 50,
        }}
      >
        {_.sortBy(features, (feature) => feature.distance).map((feature, i, list) => (
          <Image
            key={feature.imageId}
            src={feature.image}
            style={{
              maxHeight: 86,
              padding: 2,
              borderRadius: 5,
            }}
            onClick={() => showPhotoBrowser(list, i)}
          />
        ))}
      </div>
    </div>
  );
};
export default ListImages;
